window.addEventListener("scroll", () => {
    whenScroll();
});
whenScroll();

export function whenScroll() {
    if (window.scrollY == 0) {
        document.body.classList.add("top");
        document.body.classList.remove("notTop");
    } else {
        document.body.classList.remove("top");
        document.body.classList.add("notTop");
    }

    if (window.scrollY >= innerHeight / 2) {
        document.body.classList.add("halfheight");
    } else {
        document.body.classList.remove("halfheight");
    }
}
